module.exports = __webpack_public_path__ + "assets/img/Progress.dca3e1ef.png";